import { render, staticRenderFns } from "./ProCenter.vue?vue&type=template&id=1bdb5b26&scoped=true&"
import script from "./ProCenter.vue?vue&type=script&lang=js&"
export * from "./ProCenter.vue?vue&type=script&lang=js&"
import style0 from "./ProCenter.vue?vue&type=style&index=0&id=1bdb5b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdb5b26",
  null
  
)

export default component.exports